import {Dialog} from '@primer/react'
import {useButton} from '../contexts/ButtonContext'

export function DialogWrapper({onClose}: Pick<React.ComponentProps<typeof Dialog>, 'onClose'>) {
  const {buttonRef} = useButton()

  return (
    <Dialog
      title="Review import"
      width="small"
      height="small"
      returnFocusRef={buttonRef}
      onClose={onClose}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Cancel',
        },
        {
          buttonType: 'primary',
          content: 'Create rulesets',
        },
      ]}
    >
      This is where the dialog content would go.
    </Dialog>
  )
}
